var loadScript = function(url, callback){
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState){  // IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" || script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  // Others
        script.onreadystatechange = callback;
        script.onload = callback;
    }

    script.src = url;
    var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(script, x);
};

    var startProductLabel2 = function(SECOMAPP, jQuery) {
    SECOMAPP.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

    SECOMAPP.plCookie = {
        configuration: {
            expires: 365,
            path: '/',
            domain: window.location.hostname
        },
        name: 'scm_product_label_app',
        count: 'scm_product_label_count',
        isInstalled: function() {
            var count = SECOMAPP.cookie(this.count);
            if (! count) count = 0;
            count++;
            SECOMAPP.cookie(this.count, count, this.configuration);

            var scripts = document.head.getElementsByTagName('script');
            for (var i = 0; i < scripts.length; ++i) {
                if(scripts[i].innerText.indexOf('asyncLoad') >= 0 && scripts[i].innerText.indexOf("d3azqz9xba9gwd.cloudfront.net") >= 0) {
                    console.log('already has scripttag, load PL');
                    return true;
                }
            }
            
            return SECOMAPP.cookie(this.name) === "installed" && count < 3;
        },
    };

    if (SECOMAPP.page == 'product' && SECOMAPP.pl.overrideUpdateSelectors !== true) {
        if ((typeof Shopify) !== 'undefined' && (typeof Shopify.OptionSelectors) !== 'undefined')  {
            var skip = false;
            if ((typeof Shopify.urlParam) !== 'undefined')  {
                if (Shopify.urlParam("variant")) {
                    skip = true;
                }
            }

            if (! skip) {
                try {
                    Shopify.OptionSelectors.prototype.updateSelectors = function (index, options) {
                        var currValues = this.selectedValues(); // get current values
                        var variant = this.product.getVariant(currValues);
                        if (variant) {
                            this.variantIdField.disabled = false;
                            this.variantIdField.value = variant.id; // update hidden selector with new variant id
                        } else {
                            this.variantIdField.disabled = true;
                        }
                        this.onVariantSelected(variant, this, options); // callback
                        if (this.historyState != null) {
                            this.historyState.onVariantChange(variant, this, options);
                        }

                        if (!this.variantIdField.disabled) {
                            if (this.historyState == null) {
                                if ((typeof SECOMAPP.pl.showLabel) !== 'undefined') {
                                    SECOMAPP.pl.showLabel(this.variantIdField.value );
                                }
                            }
                        }
                    };

                    SECOMAPP.pl.overrideUpdateSelectors = true;
                } catch(err) {
                    console.log('SECOMAPP PL OptionSelectors version mismatch');
                }
            }
        }
    }

    if (! SECOMAPP.plCookie.isInstalled()) {
        return;
    }
    if (SECOMAPP.pl.loadedApp === true) {
        return;
    }

if ((typeof SECOMAPP) == 'undefined') {
    var SECOMAPP = {};
}
if ((typeof SECOMAPP.pl) == 'undefined') {
    SECOMAPP.pl = {};
}

//label infos
SECOMAPP.pl.labels = [
    {
        'id'            : 42865,
        'priority'      : 2,
        'hide'          : 0,
        'image'         : 'https://d3azqz9xba9gwd.cloudfront.net/storage/labels/true-to-sole/649c3f8216684.png',
                'position'      : 'top_right',
        'styles'        : '',
        'text_styles'   : '',
        'label_width'   : 30,
        'label_height'  : 30,
        'fixed_size'    : 0,
        'page'    : 'product,collection,home,search',
        'conditions'    : {
            'variant_apply' : 'matching_and_variants',
            
            'exclude_variants'      : '',
            'include_variants'      : '',
                                     'is_new'        : 'any',
                             'is_on_sale'    : 'yes',
                             'collections'   : '602975600966',
                                    'stock_status'  : 'any',
                                    'by_price'      : 'base_price',
                                        }
    },
];

SECOMAPP.isDefined = function(obj) {
    return ((typeof obj == 'undefined') ? false : true);
};
SECOMAPP.getPositionLeft = function(elem, strCssRule){
    return elem.position() != 'undefined' ? elem.position().left : 0;
};
SECOMAPP.getPositionTop = function(elem, strCssRule){
    return elem.position() != 'undefined' ? elem.position().top : 0;
};
SECOMAPP.getMarginWL = function(elem, strCssRule){
    if (typeof SECOMAPP.getCustomMarginWL === 'function') {
        return SECOMAPP.getCustomMarginWL(elem, strCssRule);
    }
    if (navigator.userAgent.search("Firefox") > -1) {
        if (typeof elem.get(0) === 'undefined') {
            return 0;
        }
        var computedStyle = window.getComputedStyle(elem.get(0));
        var margT = parseInt(computedStyle.marginLeft, 10);

        return margT;
    } else {
        var margT = elem.outerWidth(true) - elem.outerWidth();
        return margT/2;
    }
};
SECOMAPP.getMarginWR = function(elem, strCssRule){
    if (typeof SECOMAPP.getCustomMarginWR === 'function') {
        return SECOMAPP.getCustomMarginWR(elem, strCssRule);
    }
    if (navigator.userAgent.search("Firefox") > -1) {
        if (typeof elem.get(0) === 'undefined') {
            return 0;
        }
        var computedStyle = window.getComputedStyle(elem.get(0));
        var margT = parseInt(computedStyle.marginRight, 10);

        return margT;
    } else {
        var margT = elem.outerWidth(true) - elem.outerWidth();
        return margT/2;
    }
};
SECOMAPP.getMarginW = function(elem, strCssRule){
    if (navigator.userAgent.search("Firefox") > -1) {
        var margT = elem.parent().outerWidth(true) - elem.width();
    } else {
        var margT = elem.outerWidth(true) - elem.outerWidth();
    }
    return margT/2;
};
SECOMAPP.getMarginH = function(elem, strCssRule){
    var margT = elem.outerHeight(true) - elem.outerHeight();
    return margT/2;
};
SECOMAPP.getPadding = function(elem, strCssRule){
    var paddT = elem.innerWidth() - elem.width();

    return paddT;
};

SECOMAPP.pl.labelProduct = function() {
    var image = getProductImage();
    // check flexslider
    var hasFlexSlider = false;
    if (image.parents('.flexslider > .flex-viewport > .slides').length) {
        hasFlexSlider = true;
    } else if (image.parents('.flexslider > .slides').length) {
        hasFlexSlider = true;
    }

    if (hasFlexSlider) {
        var imageParent = image.parents(".flexslider").parent();
    } else {
        if ((typeof SECOMAPP.pl.lpPath) != 'undefined') {
            var imageParent = image.parents(SECOMAPP.pl.lpPath).first();
        } else {
            var imageParent = image.parents(":not(a):not(.zoomWrapper)").first();
        }
    }
    imageParent.addClass("pl-parent");

    // get customized xpath for label
    if (image && image.length > 0) {
        imageParent.prepend('<div class="pl-container pl-product">');
        var width = image.width() > 0 ? image.width() : 0;
        if (width === 0 && image.get(0)) {
            width = image.get(0).width;
        }
        var height = image.height() > 0 ? image.height() : 0;
        if (height === 0 && image.get(0)) {
            height = image.get(0).height;
        }
        jQuery('.pl-container').css({
            "margin-left"     : SECOMAPP.getMarginWL(image),
            "margin-right"    : SECOMAPP.getMarginWR(image),
            "margin-top"      : SECOMAPP.getMarginH(image),
            "margin-bottom"   : SECOMAPP.getMarginH(image),
            padding           : SECOMAPP.getPadding(image),
        });
        if (width > 0) {
            jQuery('.pl-container').css({width: width});
        }
        if (height > 0) {
            jQuery('.pl-container').css({height: height});
        }
        var variantId = getVariantId();
        if (! variantId) {
            variantId = SECOMAPP.pl.product.variants[0].id;
        }
        if (! variantId) {
            // get first available variant
            for (i = 0; i < SECOMAPP.pl.product.variants.length; i++) {
                var variant = SECOMAPP.pl.product.variants[i];
                if (variant.inventory_quantity > 0 || !variant.hasOwnProperty('inventory_management') ) {
                    variantId = variant.id;
                    break;
                }
            }
        }

        SECOMAPP.pl.showLabel(variantId);
    }
};

SECOMAPP.pl.labelCollections = function(force) {
    var productImages = getProductImages();

    searchCallback = function (json){
        if ((typeof SECOMAPP.pl.products) == 'undefined') {
            SECOMAPP.pl.products = {};
        }

        jQuery.each(json.results, function(i, product){
            if(product.variants.length !== 0){
                if (!SECOMAPP.pl.products.hasOwnProperty(product.handle) || force) {
                    if (!SECOMAPP.pl.products.hasOwnProperty(product.handle)) {
                        SECOMAPP.pl.products[product.handle] = product;
                        product.published_at = product.published_at.replace(/(\d)-/g,'$1/');
                    }

                    handle = product.handle;
                    if (!productImages.hasOwnProperty(handle)) {
                        return;
                    }
                    var productImage = productImages[handle];
                    if (productImage instanceof Array) {
                        jQuery.each(productImage, function(i, pi){
                            showLabelImage(pi, handle);
                        });
                    } else {
                        showLabelImage(productImage, handle);
                    }
                }
            }else{
                console.log('have empty variants in product');
            }
        });

        if (json.results_count > 50 && ((typeof SECOMAPP.pl.search) == 'undefined' || !SECOMAPP.pl.search.hasOwnProperty(json.query))) {
            if ((typeof SECOMAPP.pl.search) == 'undefined') {
                SECOMAPP.pl.search = {};
            }
            SECOMAPP.pl.search[json.query] = true;
            for (page = 2; page <= Math.floor((json.results_count+49) / 50); page++) {
                var query = json.query.split('&quot;').join('"');
                jQuery.getScript('/search.js?page=' + page + '&q=' + query + '&view=scm.products.handle.js&_sc=1&design_theme_id=149449081158&app=pl');
            }
        }
    };

    // get products json from handles
    var fullQuery = "";
    var h = 0;
    for (var handle in productImages) {
        if (!productImages.hasOwnProperty(handle)) {
            continue;
        }

        if (typeof (force) !== 'undefined' && force === true) {
            SECOMAPP.pl.productImages = {};
        }
        if (typeof SECOMAPP.pl.productImages == "undefined") {
            SECOMAPP.pl.productImages = {};
        }
        if (SECOMAPP.pl.productImages.hasOwnProperty(handle)) {
            continue;
        } else {
            SECOMAPP.pl.productImages[handle] = productImages[handle];
        }

        if (fullQuery.length > 0) {
            fullQuery += " OR ";
        }
        fullQuery += "handle:\"" + handle + "\"";
        h++;
        if (h >= 50) {
            jQuery.getScript('/search.js?q=' + fullQuery + '&view=scm.products.handle.js&_sc=1&design_theme_id=149449081158&app=pl');
            fullQuery = "";
            h = 0;
        }
    }
    if (h > 0) {
        jQuery.getScript('/search.js?q=' + fullQuery + '&view=scm.products.handle.js&_sc=1&design_theme_id=149449081158&app=pl');
    }
};

//get matched label
SECOMAPP.pl.showLabel = function(variantId) {
    jQuery('.pl-container.pl-product .pl-image').hide();
    var product = SECOMAPP.pl.product;
    product.published_at = product.published_at.replace(/(\d)-/g,'$1/');
    // find the variant object
    for (var i=product.variants.length-1; i>=0; i--) {
        var variant = product.variants[i];
        if (variantId == variant.id) {
            break;
        }
    }

    var match_count = 0;
    var labels = SECOMAPP.pl.labels;
    for (var j=0; j<labels.length; j++){
        var label = labels[j];
        if (label.page.indexOf('product') === -1){
            continue;
        }


        var condition = label.conditions;

        var match = true;

        // Hide if label with higher priority is already applied
        if (label.hide) {
            if (match_count > 0) {
                continue;
            }
        }

        if (condition.is_on_sale == 'yes') {
            if (match) {
                // Is On Sale
                if(!variant.hasOwnProperty('compare_at_price') || variant.compare_at_price == null) {
                    match = false;
                } else if (variant.price < variant.compare_at_price) {
                    // Percentage
                    var compare_at_price_threshold = variant.compare_at_price * 1;
                    if (variant.price > compare_at_price_threshold) {
                        match = false;
                    }
                } else {
                    match = false;
                }
            }
        } else if (condition.is_on_sale == 'no') {
            if (match) {
                if (variant.hasOwnProperty('compare_at_price')) {
                    // Percentage
                    var compare_at_price_threshold = variant.compare_at_price * 1;
                    if (variant.price <= compare_at_price_threshold ) {
                        match = false;
                    }
                }
            }
        }

        // Is New
        if (condition.is_new == 'yes') {
            // Last X Days
            if (match) {
                if ((new Date() - Date.parse(product.published_at))/86400000 >  10) {
                    match = false;
                }
            }
        } else if (condition.is_new == 'no') {
            // Last X Days
            if (match) {
                if ((new Date() - Date.parse(product.published_at))/86400000 <=  10) {
                    match = false;
                }
            }
        }

        // Collections
        if (condition.collections) {
            var collections = condition.collections.split(',').map(x=>+x)
            if (match) {
                match = false;
                for (var i = 0; i < product.collections.length; i++) {
                    var cid = product.collections[i];
                    if(collections.indexOf(cid) >= 0){
                        match = true;
                        break;
                    }
                }
            }
        }

        // Tags
        if (condition.tags) {
            var tags = condition.tags.split(',')
            if (match) {
                match = false;

                if (product.hasOwnProperty('tags')) {
                    for (var i = 0; i < product.tags.length; i++) {
                        if (tags.indexOf(product.tags[i]) >= 0) {
                            match = true;
                            break;
                        }
                    }
                }
            }
        }

        // Stock
        if (condition.stock_status == 'in_stock') {
            if (match) {
                // in stock
                if (variant.inventory_quantity < 2 && variant.hasOwnProperty('inventory_management')) {
                    match = false;
                }
            }
        } else if (condition.stock_status == 'out_of_stock') {
            if (match) {
                // out of stock
                if (variant.inventory_quantity > 0 || !variant.hasOwnProperty('inventory_management') ) {
                    match = false;
                }
            }
        } else if (condition.stock_status == 'low_stock') {
            if (match) {
                // low stock
                if (variant.inventory_quantity <= 0 || variant.inventory_quantity > 2 || !variant.hasOwnProperty('inventory_management') ) {
                    match = false;
                }
            }
        }

        // Price Range
        if(condition.hasOwnProperty('from_price') || condition.hasOwnProperty('to_price')) {
            if (match) {
                if(condition.hasOwnProperty('from_price')) {
                    if (variant.price < condition.from_price * 100) {
                        match = false;
                    }
                }
                if (condition.hasOwnProperty('to_price') && match) {
                    if (match == true && variant.price > condition.to_price * 100) {
                        match = false;
                    }
                }
            }
        }

        // Weight Range
        if(condition.hasOwnProperty('from_weight') || condition.hasOwnProperty('to_weight')) {
            if (match) {
                if(condition.hasOwnProperty('from_weight')) {
                    if (!variant.hasOwnProperty('weight') || variant.weight == 0 || variant.weight < condition.from_weight) {
                        match = false;
                    }
                }
                if (condition.hasOwnProperty('to_weight') && match) {
                    if (!variant.hasOwnProperty('weight') || variant.weight == 0 || variant.weight > condition.to_weight) {
                        match = false;
                    }
                }
            }
        }

        // Variants
        if (condition.variant_apply == 'matching_and_variants') {
            if (!match) {
                var includeVariants = condition.include_variants.split(",");
                if (jQuery.inArray(variant.id + "", includeVariants) >= 0) {
                    match = true;
                }
            } else {
                var exceptVariants = condition.exclude_variants.split(",");
                if (jQuery.inArray(variant.id + "", exceptVariants) >= 0) {
                    match = false;
                }
            }
        } else if (condition.variant_apply == 'variants') {
            match = false;
            var includeVariants = condition.include_variants.split(",");
            if (jQuery.inArray(variant.id + "", includeVariants) >= 0) {
                match = true;
            }
        }

        if (condition.starts_at || condition.ends_at) {
            if (match) {
                // Scheduled
                if (condition.starts_at) {
                    if (Date.now() < Date.parse(condition.starts_at)){
                        match = false;
                    }
                }
                if (condition.ends_at && match) {
                    if (Date.now() > Date.parse(condition.ends_at)){
                        match = false;
                    }
                }
            }
        }

        if (match) {
            match_count++;
        } else {
            continue;
        }

        // show label or create new
        var labelNodes = jQuery(".pl-container.pl-product .pl-image[data-label-id='"+label.id+"']");
        var text = label.text;
        if (labelNodes.length > 0 && (
                !label.text ||
                label.text.indexOf("{") < 0 ||
                label.text.indexOf("}") < 0
            )
        ) {
            labelNodes.first().show();
        } else {
            // create node
            var newNode = '<div data-label-id="' + label.id + '" class="pl-image ' + label.position + '" style="background-size: cover; background-image: url(' + label.image + '); width: ' + (label.label_width >= 0 ? label.label_width : 30) + (label.fixed_size ? 'px' : '%') + '; height: ' + (label.label_height >= 0 ? label.label_height : 30) + (label.fixed_size ? 'px' : '%') + ';' + (label.styles ? label.styles : '') + '">';
            if (label.text) {
                var text = label.text;
                if (text.indexOf("{SAVE_PERCENT}") >= 0) {
                    var save_percent = 0;
                    if (variant.hasOwnProperty('compare_at_price') && variant.price < variant.compare_at_price) {
                        save_percent = (variant.compare_at_price - variant.price)*100/variant.compare_at_price;
                        save_percent = Math.round(save_percent);
                    }
                    text = text.replace('{SAVE_PERCENT}', save_percent);
                }
                if (text.indexOf("{SAVE_AMOUNT}") >= 0) {
                    var save_amount = 0;
                    if (variant.hasOwnProperty('compare_at_price') && variant.price < variant.compare_at_price) {
                        save_amount = variant.compare_at_price - variant.price;
                    }
                    if (save_amount % 100 == 0) {
                        text = text.replace('{SAVE_AMOUNT}', (save_amount/100));
                    } else if (save_amount % 10 == 0) {
                        text = text.replace('{SAVE_AMOUNT}', (save_amount/100).toFixed(1));
                    } else {
                        text = text.replace('{SAVE_AMOUNT}', (save_amount/100).toFixed(2));
                    }
                }
                if (text.indexOf("{PRICE}") >= 0) {
                    text = text.replace('{PRICE}', (variant.price/100).toFixed(2));
                }
                if (text.indexOf("{NEW_FOR}") >= 0) {
                    var date_difference = (new Date() - Date.parse(product.published_at))/86400000;
                    date_difference = date_difference < 0 ? 0 : Math.ceil(date_difference);
                    text = text.replace('{NEW_FOR}', date_difference);
                }
                if (text.indexOf("{SKU}") >= 0) {
                    sku = variant.sku ? variant.sku : '';
                    text = text.replace('{SKU}', sku);
                }
                if (text.indexOf("{STOCK}")>=0) {
                    var stock = variant.inventory_quantity >= 0 ? variant.inventory_quantity : 0;
                    text = text.replace('{STOCK}', stock);
                }

                newNode += '<span class="pl-text translatable" style="' + (label.text_styles ? label.text_styles : '') + '">'+text+'</span>';
            }
            newNode += '</div>';

            jQuery('.pl-container.pl-product').append(newNode);
        }
    }
};

//get matched label
SECOMAPP.pl.showCollectionLabels = function(product, element) {
    var firstVariantId = product.hasOwnProperty('selected_or_first_available_variant_id') ?
        product.selected_or_first_available_variant_id : 0;
    var firstVariant = null;
    if (firstVariantId) {
        for (i = 0; i < product.variants.length; i++) {
            if (product.variants[i].id == firstVariantId ) {
                firstVariant = product.variants[i];
                break;
            }
        }
    }

    var match_count = 0;
    var labels = SECOMAPP.pl.labels;
    for (var j=0; j<labels.length; j++) {
        var label = labels[j];
        if(label.page.indexOf('collection') === -1){
            continue;
        }

        var condition = label.conditions;

        var match = true;

        // Hide if label with higher priority is already applied
        if (label.hide) {
            if (match_count > 0) {
                continue;
            }
        }

        if (condition.is_on_sale == 'yes') {
            if (match) {
                // Is On Sale
                if(!product.hasOwnProperty('compare_at_price') || product.compare_at_price == null) {
                    match = false;
                } else if (product.price < product.compare_at_price) {
                    // Percentage
                    var compare_at_price_threshold = product.compare_at_price * 1;
                    if (product.price > compare_at_price_threshold) {
                        match = false;
                    }
                } else {
                    match = false;
                }
            }
        } else if (condition.is_on_sale == 'no') {
            if (match) {
                if (product.hasOwnProperty('compare_at_price')) {
                    // Percentage
                    var compare_at_price_threshold = product.compare_at_price * 1;
                    if (product.price <= compare_at_price_threshold ) {
                        match = false;
                    }
                }
            }
        }

        // Is New
        if (condition.is_new == 'yes') {
            // Last X Days
            if (match) {
                if ((new Date() - Date.parse(product.published_at))/86400000 >  10) {
                    match = false;
                }
            }
        } else if (condition.is_new == 'no') {
            // Last X Days
            if (match) {
                if ((new Date() - Date.parse(product.published_at))/86400000 <=  10) {
                    match = false;
                }
            }
        }

        // Collections
        if (condition.collections) {
            var collections = condition.collections.split(',').map(x=>+x)
            if (match) {
                match = false;
                for (var i = 0; i < product.collections.length; i++) {
                    var cid = product.collections[i];
                    if(collections.indexOf(cid) >= 0){
                        match = true;
                        break;
                    }
                }
            }
        }

        // Tags
        if (condition.tags) {
            var tags = condition.tags.split(',')
            if (match) {
                match = false;
                if (product.hasOwnProperty('tags')) {
                    for (var i = 0; i < product.tags.length; i++) {
                        if (tags.indexOf(product.tags[i]) >= 0) {
                            match = true;
                            break;
                        }
                    }
                }
            }
        }

        // Stock
        if (condition.stock_status == 'in_stock') {
            if (match) {
                // in stock
                match = false;
                for (var i=0; i<product.variants.length; i++) {
                    var variant = product.variants[i];
                    if (variant.inventory_quantity >= 2 && variant.hasOwnProperty('inventory_management')) {
                        match = true;
                        break;
                    }
                }
            }
        } else if (condition.stock_status == 'out_of_stock') {
            if (match) {
                // out of stock
                for (var i=0; i<product.variants.length; i++) {
                    var variant = product.variants[i];
                    if (variant.inventory_quantity > 0 || !variant.hasOwnProperty('inventory_management')) {
                        match = false;
                        break;
                    }
                }
            }
        } else if (condition.stock_status == 'low_stock') {
            if (match) {
                // low stock (at least 1 variant low stock)
                match = false;
                for (var i=0; i<product.variants.length; i++) {
                    var variant = product.variants[i];
                    if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 2 && variant.hasOwnProperty('inventory_management') ) {
                        match = true;
                        break;
                    }
                }
            }
        }

        // Price Range
        if(condition.hasOwnProperty('from_price') || condition.hasOwnProperty('to_price')) {
            if (match) {
                if(condition.hasOwnProperty('from_price')) {
                    if (product.price < condition.from_price * 100) {
                        match = false;
                    }
                }
                if (condition.hasOwnProperty('to_price') && match) {
                    if (match == true && product.price > condition.to_price * 100) {
                        match = false;
                    }
                }
            }
        }

        // Weight Range
        if(condition.hasOwnProperty('from_weight') || condition.hasOwnProperty('to_weight')) {
            if (match) {
                // check if any variant match
                match = false;
                for (var i=0; i<product.variants.length; i++) {
                    var variant = product.variants[i];
                    match = true;
                    if(condition.hasOwnProperty('from_weight')) {
                        if (!variant.hasOwnProperty('weight') || variant.weight == 0 || variant.weight < condition.from_weight) {
                            match = false;
                        }
                    }
                    if (condition.hasOwnProperty('to_weight') && match) {
                        if (!variant.hasOwnProperty('weight') || variant.weight == 0 || variant.weight > condition.to_weight) {
                            match = false;
                        }
                    }
                    if (match) break;
                }
            }
        }

        // Variants
        if (condition.variant_apply == 'matching_and_variants') {
            if (!match) {
                var includeVariants = condition.include_variants.split(",");
                for (i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    if (jQuery.inArray(variant.id + "", includeVariants) >= 0) {
                        match = true;
                        break;
                    }
                }
            } else {
                var exceptVariants = condition.exclude_variants.split(",");
                for (i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    if (jQuery.inArray(variant.id + "", exceptVariants) >= 0) {
                        match = false;
                        break;
                    }
                }
            }
        } else if (condition.variant_apply == 'variants') {
            match = false;
            var includeVariants = condition.include_variants.split(",");
            for (i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                if (jQuery.inArray(variant.id + "", includeVariants) >= 0) {
                    match = true;
                    break;
                }
            }
        }

        if (condition.starts_at || condition.ends_at) {
            if (match) {
                // Scheduled
                if (condition.starts_at) {
                    if (Date.now() < Date.parse(condition.starts_at)){
                        match = false;
                    }
                }
                if (condition.ends_at && match) {
                    if (Date.now() > Date.parse(condition.ends_at)){
                        match = false;
                    }
                }
            }
        }

        if (match) {
            match_count++;
        } else {
            continue;
        }

        // show label or create new
        // var labelNodes = jQuery(".pl-container .pl-image[data-label-id='"+label.id+"']");

        if ((typeof SECOMAPP.pl.lpsPath) == 'undefined') {
            var labelNodes = jQuery(".pl-container .pl-image[data-label-id='"+label.id+"']", element);
        } else {
            var labelNodes = jQuery(".pl-container .pl-image[data-label-id='"+label.id+"']", jQuery(element).parents('.pl-parent').first());
        }

        if (labelNodes.length > 0) {
            labelNodes.first().show();
        } else {
            // create node
            var newNode = '<div data-label-id="' + label.id + '" class="pl-image ' + label.position + '" style="background-size: cover; background-image: url(' + label.image + '); width: ' + (label.label_width >=0 ? label.label_width : 30) + (label.fixed_size ? 'px' : '%') + '; height: ' + (label.label_height ? label.label_height : 30) + (label.fixed_size ? 'px' : '%') + ';' + (label.styles ? label.styles : '') + '">';
            if (label.text) {
                var text = label.text;
                if (text.indexOf("{SAVE_PERCENT}") >= 0) {
                    var save_percent = 0;
                    if (firstVariant) {
                        if (firstVariant.hasOwnProperty('compare_at_price') && firstVariant.price < firstVariant.compare_at_price) {
                            save_percent = (firstVariant.compare_at_price - firstVariant.price)*100/firstVariant.compare_at_price;
                            save_percent = Math.round(save_percent);
                        }
                    } else {
                        if (product.hasOwnProperty('compare_at_price') && product.price < product.compare_at_price) {
                            save_percent = (product.compare_at_price - product.price)*100/product.compare_at_price;
                            save_percent = Math.round(save_percent);
                        }
                    }
                    text = text.replace('{SAVE_PERCENT}', save_percent);
                }
                if (text.indexOf("{SAVE_AMOUNT}") >= 0) {
                    var save_amount = 0;
                    if (firstVariant) {
                        if (firstVariant.hasOwnProperty('compare_at_price') && firstVariant.price < firstVariant.compare_at_price) {
                            save_amount = firstVariant.compare_at_price - firstVariant.price;
                        }
                    } else {
                        if (product.hasOwnProperty('compare_at_price') && product.price < product.compare_at_price) {
                            save_amount = product.compare_at_price - product.price;
                        }
                    }

                    if (save_amount % 100 == 0) {
                        text = text.replace('{SAVE_AMOUNT}', (save_amount/100));
                    } else if (save_amount % 10 == 0) {
                        text = text.replace('{SAVE_AMOUNT}', (save_amount/100).toFixed(1));
                    } else {
                        text = text.replace('{SAVE_AMOUNT}', (save_amount/100).toFixed(2));
                    }
                }
                if (text.indexOf("{PRICE}") >= 0) {
                    if (firstVariant) {
                        text = text.replace('{PRICE}', (firstVariant.price/100).toFixed(2));
                    } else {
                        text = text.replace('{PRICE}', (product.price/100).toFixed(2));
                    }
                }
                if (text.indexOf("{NEW_FOR}") >= 0) {
                    var date_difference = (new Date() - Date.parse(product.published_at))/86400000;
                    date_difference = date_difference < 0 ? 0 : Math.ceil(date_difference);
                    text = text.replace('{NEW_FOR}', date_difference);
                }
                if (text.indexOf("{STOCK}")>=0) {
                    var product_inventory_quantity = 0;
                    for (var i=0; i<product.variants.length; i++) {
                        var variant = product.variants[i];
                        if (!variant.hasOwnProperty('inventory_management')) {
                            continue;
                        } else {
                            if (variant.inventory_quantity >= 0) {
                                product_inventory_quantity += variant.inventory_quantity;
                            }
                        }
                    }
                    text = text.replace('{STOCK}', product_inventory_quantity);
                }

                newNode += '<span class="pl-text translatable" style="' + (label.text_styles ? label.text_styles : '') + '">'+text+'</span>';
            }
            newNode += '</div>';

            if ((typeof SECOMAPP.pl.lpsPath) == 'undefined') {
                jQuery('.pl-container', element).append(newNode);
            } else {
                if (jQuery(element).parents('.pl-parent').length === 0) {
                    jQuery('.pl-container', element).append(newNode);
                } else {
                    jQuery('.pl-container', jQuery(element).parents('.pl-parent').first()).append(newNode);
                }
            }
        }
    }

    return null;
};

function getProductImages() {
    var productImages =
        (typeof SECOMAPP.pl.pisRegex) == 'undefined' ?
            jQuery('a[href*="/products/"]:not([href*=".jp"]):not(form a[href*="/products/"]):not(.related-products a[href*="/products/"]):not(.not-sca-pl a[href*="/products/"]):not([href*=".JP"]):not([href*=".png"]):not([href*=".PNG"])').has('img[src*="/products/"]:not([class*="not-sca-pl"]), img[src*="/no-image"], img[data-src*="/products/"]:not([class*="not-sca-pl"]), img[data-src*="/no-image"]')
        :
            jQuery(SECOMAPP.pl.pisRegex)
        ;

    var products = {};
    productImages.each(function (index, product) {
        if (!(jQuery(product).attr('href'))) {
            return;
        }
        var splits = jQuery(product).attr('href').split('/');
        var handle = splits[splits.length - 1].split(/[?#]/)[0];
        if(products.hasOwnProperty(handle)){
            var handles = products[handle];
            if (!(handles instanceof Array)) {
                handles = [handles];
                products[handle] = handles;
            }
            handles.push(product);
        } else {
            products[handle] = product;
        }
        // fix for handle has special char
        var handle2 = decodeURI(handle);
        if (handle != handle2) {
            if(products.hasOwnProperty(handle2)){
                var handles = products[handle2];
                if (!(handles instanceof Array)) {
                    handles = [handles];
                    products[handle2] = handles;
                }
                handles.push(product);
            } else {
                products[handle2] = product;
            }
        }
    });
    return products;
}

function getProductImage() {
    // old
    // var image = jQuery('.pl-product ~ img').first();
    if ((typeof SECOMAPP.pl.piRegex) == 'undefined') {
        var images = jQuery('img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".jp"],img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".JP"],img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".png"],img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".PNG"]');
    } else {
        var images = jQuery(SECOMAPP.pl.piRegex);
        if ((typeof images) == 'undefined' || images.length === 0) {
            if (typeof SECOMAPP.pl.retry === 'undefined') {
                SECOMAPP.pl.retry = 1;
            } else {
                SECOMAPP.pl.retry = SECOMAPP.pl.retry + 1;
            }
            if (SECOMAPP.pl.retry < 5) {
                setTimeout(function() {
                    SECOMAPP.pl.labelProduct();
                },1000);
            }
        }
    }
    // fix biggest image
    var maxWidth = 0;
    var mainImage;
    var title = jQuery("meta[property='og:title']").attr("content");
    if((typeof SECOMAPP.pl.piRegex) != 'undefined' && images.length == 1) {
        mainImage = images[0];
    } else {
        images.each(function (index, image) {
            if (jQuery(image).css('opacity') == "0" || jQuery(image).css('visibility') == "hidden" || jQuery(image).css('display') == "none") {
                return;
            }
            var currentWidth = jQuery(image).width();
            if (title) {
                var alt = jQuery(image).attr('alt');
                if (alt) {
                    if (alt.indexOf(title) >= 0) {
                        currentWidth *= 2;
                    }
                }
            }
            if (currentWidth > maxWidth) {
              maxWidth = currentWidth;
              mainImage = image;
            }
        });
    }
    if (mainImage === undefined && images.length > 0) {
        images.each(function (index, image) {
            if (jQuery(image).css('opacity') == "0" || jQuery(image).css('visibility') == "hidden" || jQuery(image).css('display') == "none") {
                return;
            }
            var currentWidth = image.width;
            if (title) {
                var alt = jQuery(image).attr('alt');
                if (alt) {
                    if (alt.indexOf(title) >= 0) {
                        currentWidth *= 2;
                    }
                }
            }
            if (currentWidth > maxWidth) {
              maxWidth = currentWidth;
              mainImage = image;
            }
        });
    }
    if (mainImage === undefined && images.length > 0) mainImage = images[0];
    return jQuery(mainImage);
}
SECOMAPP.pl.getVariantId = function(){
    var variantId = SECOMAPP.isDefined(Shopify.urlParam) ? Shopify.urlParam("variant") : false;
    if (! variantId) {
    variantId = location.search.split('variant=')[1]
    }
    if (! variantId) {
    var elem = SECOMAPP.isDefined(Shopify.OptionSelectors) ? document.getElementById(Shopify.OptionSelectors.domIdPrefix) : false;
    if (!elem) {
    return false;
    }
    var option = elem.querySelector("[selected]");

    if (!option) {
    return false;
    }

    variantId = option.value;
    }

    return variantId;
}

function getVariantId() {
    var variantId = SECOMAPP.isDefined(Shopify.urlParam) ? Shopify.urlParam("variant") : false;
    if (! variantId) {
        variantId = location.search.split('variant=')[1]
    }
    if (! variantId) {
      var elem = SECOMAPP.isDefined(Shopify.OptionSelectors) ? document.getElementById(Shopify.OptionSelectors.domIdPrefix) : false;
      if (!elem) {
        return false;
      }
      var option = elem.querySelector("[selected]");

      if (!option) {
        return false;
      }

      variantId = option.value;
    }

    return variantId;
}

function showLabelImage(productImage, handle) {
    if ((typeof SECOMAPP.pl.pi2sRegex) !== 'undefined') {
        var images = jQuery(SECOMAPP.pl.pi2sRegex, productImage);
        if (images.length == 0) {
            var images = jQuery(SECOMAPP.pl.pi2sRegex);
        }
    } else {
        var images = jQuery("img:not(.sca-fg-img-collect)", productImage);
    }
    var outside = false;
    if (images.length == 0) {
        images = jQuery('img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".jp"],img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".png"],img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".JP"],img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".PNG"]', jQuery(productImage).parent());
        outside = true;
    }
    if (images.length == 0) {
        images = jQuery('img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".jp"],img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".png"],img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".JP"],img[src*="/products/"][src*="/cdn.shopify.com/s/files/"][src*=".PNG"]', jQuery(productImage).parent().parent());
        outside = true;
    }
    if (images.length == 0) {
        var image = jQuery(productImage);
    } else {
        var image = images.first();
    }
    if ((typeof SECOMAPP.pl.lpsPath) == 'undefined') {
        var imageParent = image.parents(":not(a):not(.zoomWrapper)").first().addClass("pl-parent");
        if (jQuery('.pl-container.pl-collection', image.parents(".pl-parent").first()).length === 0) {
            image.parents(":not(.zoomWrapper):not(a:has(.zoomWrapper))").first().prepend('<div class="pl-container pl-collection">');
        }
    } else {
        var imageParent = image.parents(SECOMAPP.pl.lpsPath).first().addClass("pl-parent");
        if (jQuery('.pl-container.pl-collection', image.parents(".pl-parent").first()).length === 0) {
            image.parents(SECOMAPP.pl.lpsPath).first().prepend('<div class="pl-container pl-collection">');
        }
        outside = true;
    }
    if (outside) productImage = imageParent;
    $productImage = jQuery(productImage);
    jQuery('.pl-collection', productImage).css({
        "margin-left"         : SECOMAPP.getMarginWL($productImage),
        "margin-right"        : SECOMAPP.getMarginWR($productImage),
        "margin-top"          : SECOMAPP.getMarginH($productImage),
        "margin-bottom"       : SECOMAPP.getMarginH($productImage),
        padding               : SECOMAPP.getPadding($productImage),
    });
    var product = SECOMAPP.pl.products[handle];
    SECOMAPP.pl.showCollectionLabels(product, productImage);
}


SECOMAPP.pl.setRedirectLabel = function(url){
    var labels = document.querySelectorAll('.pl-image');
    labels.forEach(label => {
        label.addEventListener("click", function(){
            window.location.href = url;
        });
    });
}

function resizeLabelImage(productImage) {
    $productImage = jQuery(productImage);
    jQuery('.pl-collection', productImage).css({
        "margin-left"         : SECOMAPP.getMarginWL($productImage),
        "margin-right"        : SECOMAPP.getMarginWR($productImage),
        "margin-top"          : SECOMAPP.getMarginH($productImage),
        "margin-bottom"       : SECOMAPP.getMarginH($productImage),
        padding               : SECOMAPP.getPadding($productImage),
    });
}

// remove element added by liquid in old version
jQuery("div.pl-container").remove();

if (SECOMAPP.page == 'product' ) {
    SECOMAPP.pl.labelProduct();

    jQuery( window ).resize(function() {
        var image = getProductImage();
        if (image && image.length > 0) {
            jQuery('.pl-product').css({
                width             : image.width() > 0 ? image.width() : image.get(0).width,
                height            : image.height() > 0 ? image.height() : image.get(0).height,
                "margin-left"     : SECOMAPP.getMarginWL(image),
                "margin-right"    : SECOMAPP.getMarginWR(image),
                "margin-top"      : SECOMAPP.getMarginH(image),
                "margin-bottom"   : SECOMAPP.getMarginH(image),
                padding           : SECOMAPP.getPadding(image),
            });
        }
    });

    jQuery('.single-option-selector').change(function() {
      if (!SECOMAPP.isDefined(Shopify.urlParam) ||
          !SECOMAPP.isDefined(Shopify.OptionSelectors)
         ) {
        console.log('No Shopify.OptionSelectors');
        return;
      }
      var variantId = getVariantId();
      if (! variantId) {
          console.log('no variantId');
          return false;
      }

      SECOMAPP.pl.showLabel(variantId);
    });
}
if (SECOMAPP.page == 'collection' || SECOMAPP.page == 'product') {

    SECOMAPP.pl.labelCollections();

    jQuery( window ).resize(function() {
        var productImages = getProductImages();
        for (var handle in productImages) {
            var productImage = productImages[handle];

            if (productImage instanceof Array) {
                jQuery.each(productImage, function(i, pi){
                    resizeLabelImage(pi);
                });
            } else {
                resizeLabelImage(productImage);
            }
        }
    });

    if (SECOMAPP.page == 'collection'){
        jQuery(document).ajaxSuccess(function() {
            SECOMAPP.pl.labelCollections();
        });
    }
}
    SECOMAPP.pl.loadedApp = true;
};

    var SECOMAPP = SECOMAPP || new Object();
    SECOMAPP.pl = SECOMAPP.pl || new Object();
    if ((typeof jQuery === 'undefined')) {
        loadScript('//code.jquery.com/jquery-1.11.1.min.js', function() {
            SECOMAPP.jQuery = jQuery.noConflict();
            SECOMAPP.jQuery.ajaxSetup({
                cache: true
            });
            SECOMAPP.jQuery(document).ready(function() {
                SECOMAPP.pl.jQuery = SECOMAPP.jQuery;
                SECOMAPP.pl.loadedJs = true;
                startProductLabel2(SECOMAPP, SECOMAPP.jQuery);
            });
        });
    } else {
        jQuery.ajaxSetup({
            cache: true
        });
        jQuery(document).ready(function() {
            SECOMAPP.pl.jQuery = jQuery;
            SECOMAPP.pl.loadedJs = true;
            startProductLabel2(SECOMAPP, jQuery);
        });
    }
